const theme = {
  title: "dark",
  colors: {
    primary: "#000000",
    secondary: "#ffffff",
    text: "#ffffff",
    neutral: "#D9D9D9",
    transparenceBar: "rgba(0, 0, 0,0.5)",
    transparenceBarHover: "rgba(217, 217, 217,.5)",
    navBar: "rgba(0, 0, 0,0.95)",
    filter: "invert(0)",
  },
};

export default theme;
